import { authClient, API } from "../index";

/**
 * Lista operaciones de trading (backend GET .../operation/trading-operations).
 * @param {Record<string, string|number|undefined>} params — status, exchange, symbol, source, strategy, from, to, limit, skip
 */
export const getTradingOperations = (params = {}) => {
  return authClient().get(`${API}/exchange/operation/trading-operations`, {
    params,
  });
};

export const getTradingOperationById = (id) => {
  return authClient().get(
    `${API}/exchange/operation/trading-operations/${encodeURIComponent(id)}`,
  );
};
